import { render, staticRenderFns } from "./RelatorioCotasUnidadeListFiltroModalItemInput.vue?vue&type=template&id=6853a71e"
import script from "./RelatorioCotasUnidadeListFiltroModalItemInput.vue?vue&type=script&lang=js"
export * from "./RelatorioCotasUnidadeListFiltroModalItemInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports